export const baseUrl = 'https://nufakerserver.herokuapp.com/';